<template>
  <div class="c8-datebox">
    <a
      v-for="(item, index) in tabButtons"
      :key="`tab-${index}`"
      class="button-primary c8-datebox__item"
      :class="{ 'active': buttonActived === item.val }"
      @click.prevent="sendTab(item.val)"
    >
      <span class="button-primary__text">{{ item.name }}</span>
    </a>
    <div v-if="!hideDatePicker" class="button-outline c8-datebox__item" :class="{ 'active': buttonActived === 'datePicker' }">
      <span class="button-outline__text">{{ formatDate(currentDate) }}</span>
      <el-date-picker
        ref="datePicker"
        v-model="currentDate"
        type="date"
        placeholder="选择日期"
        :clearable="false"
        :picker-options="pickerOptions"
        @change="datePickerChanged"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getLotteryDataDurationMap } from '@/utils/commonLib'

export default {
  name: 'DateFilterTab',
  model: {
    prop: 'value', // 绑定的值，通过父组件传递
    event: 'change' // 自定义时间名
  },
  props: {
    // 生成按鈕
    tabButtons: {
      type: Array,
      default: () => {
        return [
          { name: '今天', val: dayjs().format('YYYY-MM-DD') },
          { name: '昨天', val: dayjs().subtract(1, 'days').format('YYYY-MM-DD') },
          { name: '近30期', val: '30' },
          { name: '近60期', val: '60' },
          { name: '近90期', val: '90' }
        ]
      }
    },
    // 預設高亮
    // 如果要預設日情選擇器高亮請把 defaultActived 帶 'datePicker' 即可
    defaultActived: {
      type: String,
      default: '30'
    },
    // 隱藏日期選擇器
    hideDatePicker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentDate: new Date(),
      currentTab: '',
      buttonActived: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  watch: {
    '$route': {
      handler(newVal) {
        this.updatePickerOptions()
      },
      immediate: true
    }
  },
  mounted() {
    this.buttonActived = this.defaultActived
  },
  methods: {
    // 時間選擇器變化時
    datePickerChanged(val) {
      if (val) {
        this.buttonActived = 'datePicker'
        this.$emit('change', dayjs(val).format('YYYY-MM-DD'))
      }
    },
    sendTab(val) {
      this.buttonActived = val
      this.$emit('change', val)

      // 如果是時間連動 el-date-picker
      if (/^\d{4}\-\d{2}\-\d{2}/.test(val)) {
        this.currentDate = new Date(val.replace(/\-/g, '/'))
      }
    },
    formatDate(date) {
      return dayjs(date).format('YYYY/MM/DD')
    },
    updatePickerOptions() {
      const { lottery_code } = this.$route.params
      const lotteryMap = getLotteryDataDurationMap(lottery_code)
      const minDate = dayjs().subtract(lotteryMap.duration, 'day').format('YYYY-MM-DD')
      this.pickerOptions = {
        disabledDate(time) {
          const defaultCondition = time.getTime() > Date.now()
          const disabledCondition = defaultCondition || (minDate && time.getTime() < new Date(minDate).getTime())
          return disabledCondition
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .c8-datebox {

    .c8-datebox__item {
      position: relative;

      & /deep/ {
        .el-date-editor {
          // display: none;
          opacity: 0;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;

          .el-input__inner {
            height: 100%;
            line-height: 100%;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    .c8-datebox__item .button-outline__text::after {
      content: '';
      background: url('~assets/style/desktop/img/date.png') no-repeat center;
      background-size: contain;
      display: inline-block;
      position: relative;
      left: 8px;
      top: calc(50% - .4375rem);
      width: .875rem;
      height: .875rem;
    }
    .button-outline:hover .button-outline__text::after {
      background: url('~assets/style/desktop/img/date-p.png') no-repeat center;
      background-size: contain;
    }
    .button-outline.active .button-outline__text::after {
      background: url('~assets/style/desktop/img/date-w.png') no-repeat center;
      background-size: contain;
    }

  }
</style>
